import {
    Accordion,
    AccordionHeader,
    AccordionItem,
    AccordionPanel,
    CheckboxOnChangeData,
    Label,
    makeStyles,
    tokens,
} from '@fluentui/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useReturnDetails } from '../../hooks/returnDetails/useReturnDetails';
import { TaxReturnItemRecord } from '../../model';
import { ShowableTaxReturnItemRecord } from '../add-return/AddReturnPanel';
import EditReturnAdvancedEntitySection from './EditReturnAdvancedEntitySection';
import EditReturnAdvancedOptionsSection from './EditReturnAdvancedOptionsSection';

export interface IAdvancedEntityOptions {
    taxReturnData: ShowableTaxReturnItemRecord | undefined;
    setTaxReturn: (value: TaxReturnItemRecord | undefined) => void;
    setHasChanges: () => void;
    hasEditTaxReturnsDataEnabled?: boolean;
}

const useStyles = makeStyles({
    accordionContentStyles: {
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 0',
        gap: '10px',
        width: '300px',
    },
    accordionHeaderStyles: {
        '& button': {
            backgroundColor: 'white',
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            borderBottom: '1px solid lightgray',
        },
    },
    accordionItemStyles: {
        backgroundColor: tokens.colorNeutralBackground3,
        minWidth: '344px',
        border: '1px solid lightgray',
    },
    detailViewLabelStyles: {
        display: 'inline-block',
        padding: '5px 0',
    },
});

const AdvancedEntityOptions: React.FC<IAdvancedEntityOptions> = ({
    setHasChanges,
    taxReturnData,
    setTaxReturn,
    hasEditTaxReturnsDataEnabled = true,
}) => {
    const { t } = useTranslation();
    const { accordionContentStyles, accordionHeaderStyles, accordionItemStyles, detailViewLabelStyles } = useStyles();
    const { customGroups, customRanges } = useReturnDetails();

    const onChangeDropdown = (data: any, key: string) => {
        setTaxReturn({ ...taxReturnData, [key]: data });
        setHasChanges();
    };

    const onChangeCheckbox = (data: CheckboxOnChangeData, key: string) => {
        setTaxReturn({ ...taxReturnData, [key]: data.checked });
        setHasChanges();
    };

    const updateTaxReturnAndSetHasChanges = (data: ShowableTaxReturnItemRecord) => {
        setTaxReturn(data);
        setHasChanges();
    };

    return (
        <>
            <Label className={detailViewLabelStyles}>{t('detailView')}</Label>
            <Accordion collapsible multiple defaultOpenItems={['1', '2']}>
                <AccordionItem value='1' className={accordionItemStyles}>
                    <AccordionHeader className={accordionHeaderStyles}>{t('advancedEntity').toString()}</AccordionHeader>
                    <AccordionPanel>
                        <div className={accordionContentStyles}>
                            <EditReturnAdvancedEntitySection
                                taxReturnData={taxReturnData}
                                customGroups={customGroups}
                                customRanges={customRanges}
                                onChangeCheckbox={onChangeCheckbox}
                                onChangeDropdown={onChangeDropdown}
                                hasEditTaxReturnsDataEnabled={hasEditTaxReturnsDataEnabled}
                            />
                        </div>
                    </AccordionPanel>
                </AccordionItem>
                <AccordionItem value='2' className={accordionItemStyles} style={{ marginTop: 10 }}>
                    <AccordionHeader className={accordionHeaderStyles}>{t('advancedOptions').toString()}</AccordionHeader>
                    <AccordionPanel>
                        <div className={accordionContentStyles}>
                            <EditReturnAdvancedOptionsSection
                                taxReturnData={taxReturnData}
                                customGroups={customGroups}
                                onChangePostAmountGroup={(data) => onChangeDropdown(data, 'updateColumnFileKey')}
                                onChangePostAmountOption={updateTaxReturnAndSetHasChanges}
                                hasEditTaxReturnsDataEnabled={hasEditTaxReturnsDataEnabled}
                            />
                        </div>
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </>
    );
};

export default AdvancedEntityOptions;
